var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BrokerageConsoleLayout',[_c('div',{class:[_vm.$style.container]},[_c('el-tree',{class:[_vm.$style.nodeTree],attrs:{"data":_vm.tree,"props":_vm.tree_props},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return [_c('div',{class:[
            _vm.$style.childrenLabel,
            _vm.$style[
              ("depth-" + (typeof data.depth === 'undefined' ? 'root' : data.depth % 4))
            ] ]},[_vm._v("\n          "+_vm._s(node.label)+"\n        ")])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }